/**
 * Commission Adjustments - Overview page showing all adjustments across all brands
 * Uses the reusable CommissionAdjustmentsTable component
 */

import React from 'react';
import CommissionAdjustmentsTable from '../components/CommissionAdjustments/CommissionAdjustmentsTable';

export default function CommissionAdjustments() {
  return (
    <CommissionAdjustmentsTable
      brandId={null}
      showBrandColumn={true}
      title="Commission Adjustments"
      subtitle="Manage manual commission adjustments across all brands"
      embedded={false}
    />
  );
}
